import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-210e891a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "left" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "right" };
import { onMounted, ref } from 'vue';
import { useIntersectionObserver, useAppNavigation } from '@apparatix/composables';
import { AppStore } from '../stores/AppStore';
import Logo from './Logo.vue';
import AccountMenu from './AccountMenu.vue';
import SupportMenu from './SupportMenu.vue';
import NavigationOverflowDropdown from './NavigationOverflowDropdown.vue';
import DynamicIcon from '@apparatix/icons/DynamicIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppHeader',
    setup(__props) {
        const { syncOverflow } = useAppNavigation();
        const parentRef = ref(null);
        const itemRefs = ref([]);
        const { observe } = useIntersectionObserver();
        const observerCallback = (entries) => {
            entries.forEach(entry => {
                const { target } = entry;
                syncOverflow(target, !entry.isIntersecting);
            });
        };
        const navigateToDashboard = () => AppStore.navigationItems.find(x => x.label.toLowerCase() === 'dashboard')?.command();
        onMounted(() => {
            observe(parentRef.value, itemRefs.value, observerCallback);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Logo, {
                        url: "#",
                        "on-click": navigateToDashboard
                    })
                ]),
                _createElementVNode("div", {
                    ref_key: "parentRef",
                    ref: parentRef,
                    class: "center"
                }, [
                    _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AppStore).navigationItems, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: item.uuid,
                                ref_for: true,
                                ref_key: "itemRefs",
                                ref: itemRefs,
                                class: _normalizeClass(["nav-item", { active: _unref(AppStore).activePage.label === item.label }]),
                                onClick: item.command
                            }, [
                                _createElementVNode("span", null, [
                                    _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                    (item.icon)
                                        ? (_openBlock(), _createBlock(DynamicIcon, {
                                            key: 0,
                                            name: item.icon
                                        }, null, 8, ["name"]))
                                        : _createCommentVNode("", true)
                                ])
                            ], 10, _hoisted_3));
                        }), 128))
                    ])
                ], 512),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(NavigationOverflowDropdown),
                    _createVNode(SupportMenu),
                    _createVNode(AccountMenu, {
                        username: _unref(AppStore).currentUser.displayName
                    }, null, 8, ["username"])
                ])
            ]));
        };
    }
});
